import SubActivityView from '../../sub-activity/sub-activity-view';
import { InteractiveResponseContainer } from '../interactive-response.style';
import {
  InteractiveCategoriseSmallAttempt,
  ViewProps,
} from './interactive-response-categorise.constants';
import InteractiveResponseCategoriseSmall from './play/interactive-response-categorise-small';
import { InteractiveResponseMobileWrapper } from '../shared/interactive-response-shared.style';
import type { InteractiveResponseAnswerFragment } from '../../../present/activity-answers.graphql.generated';
import InteractiveDragDrop from '../../shared/interactive-drag-drop/interactive-drag-drop';

const InteractiveResponseCategoriseSmallView = ({
  isPlaying,
  finishGame,
  openModal,
  attemptAnswers,
  showAnswer,
  ...props
}: ViewProps & {
  openModal?: () => void;
  isPlaying: boolean;
  finishGame: () => void;
  playStart: () => void;
  playClick: () => void;
  toggleAudio: () => void;
  playAudio: boolean;
  onAnswerAttempt: InteractiveCategoriseSmallAttempt;
  attemptAnswers?: InteractiveResponseAnswerFragment;
  showAnswer: boolean;
}) => {
  return (
    <InteractiveDragDrop>
      <InteractiveResponseMobileWrapper>
        <SubActivityView
          withTTSButton
          componentId={props.id}
          componentType={props.type}
          subActivityDetails={props.subActivityProperties}
        >
          <InteractiveResponseContainer>
            <InteractiveResponseCategoriseSmall
              {...props}
              attemptAnswers={attemptAnswers}
              onClose={finishGame}
              showAnswer={showAnswer}
            />
          </InteractiveResponseContainer>
        </SubActivityView>
      </InteractiveResponseMobileWrapper>
    </InteractiveDragDrop>
  );
};

export default InteractiveResponseCategoriseSmallView;
